<template>
<v-layout v-bind="layout">
	<v-flex xs6>
		<v-text-field
		v-model="search"
		append-icon="fa-search"
		label="Search"
		single-line
		hide-details>
		</v-text-field>
	</v-flex>
	<v-spacer></v-spacer>
	<v-flex xs5>
		<v-select
		v-model="states"
		:items="stateOptions"
		label="State"
		multiple
		></v-select>
	</v-flex>
</v-layout>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'

export default {
	name: "JmFilterEntity",

	props: {
		entities: Array
	},

	data () {
		return {
			stateOptions: [
				{ text: "Recent", value: "recent" },
				{ text: "Active", value: "active" },
				{ text: "Inactive", value: "inactive" }
			],
			search: "",
			states: [ "recent", "active" ],
			isDirty: false,
			isFiltering: false,
			filteredEntities: []
		}
	},

	watch: {

		search () {
			this.isDirty = true;
			this.applyFiltersDebounced();
		},

		states () {
			this.isDirty = true;
			this.applyFiltersDebounced();
		},

		entities () {
			this.applyFilters();
		},

		filteredEntities () {
			this.$emit('filtered', this.sortedEntities);
		}
	},

	computed: {

		layout () {
			const layout = {};

			if (this.$vuetify.breakpoint.mdAndUp) {
				layout.row = true;
			} else {
				layout.column = true;
			}

			return layout;
		},

		sortedEntities () {
			function _sorter (a, b) {
				return a.displayName() > b.displayName()
					? 1
					: a.displayName() < b.displayName()
						? -1
						: 0;
			}

			return this.filteredEntities.sort(_sorter);
		}

	},

	methods: {

		applyFilters () {
			let entities = [];

			if (this.states.length) {
				for (let entity of this.entities) {
					const isRecent = (moment() - moment(entity.updatedOn)) < 24*3600*1000;
					const isActive = entity.data.state != 'inactive';

					if (isActive && this.states.includes("active")) {
						entities.push(entity);
					} else if (!isActive && this.states.includes("inactive")) {
						entities.push(entity);
					} else if (isRecent && this.states.includes("recent")) {
						entities.push(entity);
					}
				}
			}

			if (this.search.trim()) {
				const rx = this.search.match(/^\/(.*)\/(.*)$/);
				const search = rx
					? new RegExp(rx[1], rx[2])
					: new RegExp(this.search, "i");

				entities = entities.filter(e => e.match(search));
			}

			this.filteredEntities = entities;
			return entities;
		},

		applyFiltersDebounced: _.debounce( function () {
			this.isFiltering = true;
			this.applyFilters();
			this.isFiltering = false;
			this.isDirty = false;
		}, 350)
	}
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/FilterWidgets/Entity.vue